import { useQuery } from 'react-query';
import { getPrivateApi } from '../../../../services/api';
import { purge } from '@vy/utils';
import type { CustomUseQueryOptions } from '../../requests-types/custom-use-query-options';
import { useActivatedIntegration } from '../../../use-activated-integration';
import { INTEGRATION_PROVIDERS } from '@vy/types';
import type { XeroGetCustomersResponse } from '@vy/api-definition';
import { queryKeys } from '../../../../services/query-key/query-keys';

export function useXeroCustomers(
  searchParam?: string,
  options?: CustomUseQueryOptions<XeroGetCustomersResponse>,
) {
  const isXeroActivated = useActivatedIntegration(INTEGRATION_PROVIDERS.xero);

  const queryDeps = purge([searchParam]);

  return useQuery(
    queryKeys.xeroCustomers(...queryDeps),
    async () => {
      const api = getPrivateApi();
      const response = await api.xeroGetCustomers({ search: searchParam });

      return response;
    },
    {
      ...options,
      enabled: isXeroActivated,
    },
  );
}
